module.exports = __webpack_public_path__ + "img/22. Delete.3eac7692.svg";